module.exports = __webpack_public_path__ + "img/p-single-6.8533920a.jpg";